import { render, staticRenderFns } from "./SaiDateTplDetail.vue?vue&type=template&id=556f2bcc&scoped=true&"
import script from "./SaiDateTplDetail.vue?vue&type=script&lang=js&"
export * from "./SaiDateTplDetail.vue?vue&type=script&lang=js&"
import style0 from "./SaiDateTplDetail.vue?vue&type=style&index=0&id=556f2bcc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556f2bcc",
  null
  
)

export default component.exports